import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Tooltip } from "@material-ui/core";
import Leftsiderbar from "../home/allcmp/Leftsidebar";
import MaterialTable from "material-table";
import { API_URL } from "../../../config";
import Top from "../Top";
import OrderView from "./OrderView";
import PaymentDetailModal from "./PaymentDetailModal";
import ResendConfirmationModal from "./ResendConfirmationModal";
import generateOrderPdf from "./generateOrderPdf";

const useStyles = makeStyles((theme) => ({
  customTooltip: {
    backgroundColor: "black",
    fontSize: "15px",
  },
  error: {
    color: "#f14668",
    fontSize: "14px !important",
    paddingTop: "3px",
    wordBreak: "break-all",
  },
}));

const Orders = () => {
  const classes = useStyles();
  const [data, setData] = useState([]);
  const [dataById, setDataById] = useState([]);
  const [openEdit, setOpenEdit] = useState(false);
  const [openPaymentModal, setOpenPaymentModal] = useState(false);
  const [openResendModal, setOpenResendModal] = useState(false);
  const [selectedOrderId, setSelectedOrderId] = useState(null);
  const handleEditPop = () => setOpenEdit(!openEdit);
  const handleEditOpen = () => setOpenEdit(true);

  useEffect(() => {
    getOrders();
  }, []);
  const columns = [
    {
      title: "Order Id",
      field: "order_id",
    },
    // {
    //   title: "Quantity",
    //   field: "quantity",
    // },
    {
      title: "Customer Name",
      field: "name",
    },
    {
      title: "Customer Email",
      field: "email",
    },
    {
      title: "Order Date",
      // title: "Date of Delivery",
      field: "created",
      cellStyle: {
        textAlign: "center",
      },
      headerStyle: {
        textAlign: "center", // Align the header to the center
        width:'130px'
      },
    },
    {
      title: "Order Status",
      field: "order_status",
    },
    {
      title: "Total Amount",
      field: "total_amount",
    },
    {
      title: "Action",
      field: "action",
    },
  ];

  const getOrders = () => {
    fetch(API_URL + "/get/all-order", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    }).then(async (response) => {
      if (response.status == 200) {
        const resp = await response.json();
        
        // debugger
        let _temp = [];
        resp?.items?.map((v, i) => {
         
          
          let bill = JSON.parse(v.billing_address_info)?.fname;
          _temp.push({
            order_id: v.order_id,
            created:convertDateString(v.created),
            name:
              JSON.parse(v.shipping_address_info)?.fname +
              " " +
              JSON.parse(v.shipping_address_info)?.lname,
            email: JSON.parse(v.shipping_address_info)?.email,
            quantity: v.quantity,
            delivery_date: v.delivery_date,
            order_status:
              v.order_status == "" || null
                ? "Incomplete"
                : v.order_status + "ED",
            total_amount:"$" + " " + v.discounted_amount && parseFloat(v.discounted_amount)>0? (parseFloat(v.total_amount)-parseFloat(v.discounted_amount)).toFixed(2):parseFloat(v.total_amount).toFixed(2),
            action: (
              <p className="action-p">
                <Tooltip
                  classes={{
                    tooltip: classes.customTooltip,
                  }}
                  title="View"
                  placement="top"
                >
                  <i
                    className={"fa fa-eye action-icon"}
                    onClick={() => handleView(v.order_id)}
                  ></i>
                </Tooltip>
                <Tooltip
                  classes={{
                    tooltip: classes.customTooltip,
                  }}
                  title="Payment details"
                  placement="top"
                >
                  <i
                    className={"fa fa-credit-card action-icon_txn"}
                    onClick={() => handleViewPayment(v.order_id)}
                    sty
                  ></i>
                </Tooltip>
                <Tooltip
                  classes={{
                    tooltip: classes.customTooltip,
                  }}
                  title="Resend Confirmation Email"
                  placement="top"
                >
                  <i
                    className={"fa fa-envelope action-icon_txn"}
                    onClick={() => handleResendConfirmation(v.order_id)}
                  ></i>
                </Tooltip>
                <Tooltip
                  classes={{
                    tooltip: classes.customTooltip,
                  }}
                  title="Download Order Confirmation"
                  placement="top"
                >
                  <i
                    className={"fa fa-download action-icon_txn"}
                    onClick={() => handleDownloadPdf(v.order_id)}
                  ></i>
                </Tooltip>
              </p>
            ),
          });
        });
        setData(_temp);
      } else if (response.status == 401) {
        logout();
      } else {
        alert("network error");
      }
    });
  };

  const getOrdersById = (id) => {
    fetch(API_URL + `/get/order/by/${id}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    }).then(async (response) => {
      if (response.status == 200) {
        const resp = await response.json();
        // debugger
        
        let _temp = [];
        resp.items.map((item, i) => {
     
        
          _temp.push({
            shipping_address_info: JSON.parse(item.shipping_address_info),
            billing_address_info: JSON.parse(item.billing_address_info),
            discounted_amount: item.discounted_amount,
            coupon_code: item.coupon_code,
            total_amount: item.discounted_amount && parseFloat(item.discounted_amount)>0? (parseFloat(item.total_amount)-parseFloat(item.discounted_amount)).toFixed(2):parseFloat(item.total_amount).toFixed(2),
            product_total_price: item.product_total_price,
            Shipping_fee: item.Shipping_fee,
            items: item.items,
            shipping_method:item.shipping_method,
            created:convertDateString(item.created),
            txn_body:item.transaction_body,
            txn_id:item.transaction_id,
            id:item.id,
            device_details: item.device_details 
          });
        });
        setDataById(_temp);
      } else if (response.status == 401) {
        logout();
      } else {
        alert("network error");
      }
    });
  };
  
  const convertDateString = (inputString) =>{
    const date = new Date(inputString);

    const year = date.getUTCFullYear().toString(); // Get last two digits of the year
    const month = String(date.getUTCMonth() + 1).padStart(2, '0'); // Month is zero-based, so add 1 and pad with 0 if needed
    const day = String(date.getUTCDate()).padStart(2, '0'); // Pad day with 0 if needed
    
    return `${year}-${month}-${day}` 
  }

  const logout = () => {
    localStorage.clear();
    window.location.reload();
  };

  const handleView = (value) => {
    handleEditOpen();
    getOrdersById(value);
  };
  const handleViewPayment = (value) => {
    setOpenPaymentModal(true)
    getOrdersById(value);
  };
  const handleResendConfirmation = (value) => {
    setSelectedOrderId(value);
    setOpenResendModal(true);
  };

  const handleDownloadPdf = (id) => {
    fetch(API_URL + `/get/order/by/${id}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    }).then(async (response) => {
      if (response.status == 200) {
        const resp = await response.json();
        const item = resp.items?.[0];
        if (!item) return;
        generateOrderPdf({
          order_id: item.order_id ?? id,
          created: convertDateString(item.created),
          billing_address_info: JSON.parse(item.billing_address_info),
          shipping_address_info: JSON.parse(item.shipping_address_info),
          items: item.items,
          discounted_amount: item.discounted_amount,
          total_amount:
            item.discounted_amount && parseFloat(item.discounted_amount) > 0
              ? (parseFloat(item.total_amount) - parseFloat(item.discounted_amount)).toFixed(2)
              : parseFloat(item.total_amount).toFixed(2),
          product_total_price: item.product_total_price,
          Shipping_fee: item.Shipping_fee,
          shipping_method: item.shipping_method,
          txn_body: item.transaction_body,
          txn_id: item.transaction_id,
        });
      } else if (response.status == 401) {
        logout();
      } else {
        alert("network error");
      }
    });
  };

  return (
    <div className="">
      <div className="cmail">
        <Top />
      </div>
      <div className="wrp-dashbord">
        <div className="cemail-left">
          <Leftsiderbar />
        </div>
        <div className="right-section">
          <div className="onlineaccess-wrp">
            <div className="onlineaccess-child1">
              <h3>Orders</h3>
            </div>
            {/* <div className="add-btn">
              <button onClick={handleAddProduct}>Add Product</button>
            </div> */}
          </div>

          <div className="wrp-bankform" style={{marginTop:"1rem"}}>
            <div className="mobiletable">
              <div style={{ maxWidth: "100%" }}>
                <MaterialTable
                  options={{
                    search: true,
                    showTitle: false,
                    toolbar: true,
                    pageSize: 10,
                  }}
                  columns={columns}
                  data={data}
                  title=""
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <OrderView
        handleEditPop={handleEditPop}
        openEdit={openEdit}
        dataById={dataById}
      />
      <PaymentDetailModal
        setOpenPaymentModal={setOpenPaymentModal}
        openPaymentModal={openPaymentModal}
        dataById={dataById}
      />
      <ResendConfirmationModal
        open={openResendModal}
        onClose={() => setOpenResendModal(false)}
        orderId={selectedOrderId}
        onResendSuccess={() => {
          // Optional: refresh orders list after successful resend
          getOrders();
        }}
      />
    </div>
  );
};

export default Orders;
